import React from "react";
import HomeOrganizationPresentation from "../../presentation/HomeOrganizationPresentation/HomeOrganizationPresentation";
import { HomeOrganizationContainerProps } from "../../types/types";

const HomeOrganizationContainer: React.FC<HomeOrganizationContainerProps> = ({
  organizatoinID,
  onSelectOrganization,
  term,
  onTerm
}) => {
  return (
    <HomeOrganizationPresentation
      organizatoinID={organizatoinID}
      onSelectOrganization={onSelectOrganization}
      term={term}
      onTerm={onTerm}
    />
  )
}

export default HomeOrganizationContainer
